import {LocalData} from "ng2-completer";
import {GbCompleterGemeindeListEntry} from "./gbCompleterGemeindeListEntry";

export class GemeindeLocalData extends LocalData {

  protected extractMatches(data: any[], term: string) {
    const matches = super.extractMatches(data, term);
    if (/^\d+$/.test(term) || /^\d{3,4}\.[\d\w]+$/.test(term)) {
      return matches.sort(this.sortByBfsKreis);
    }
    return matches.sort(this.sortByTitle);
  }

  sortByBfsKreis(a: GbCompleterGemeindeListEntry, b: GbCompleterGemeindeListEntry) {
    if (a.bfsNummer < b.bfsNummer) {
      return -1;
    }
    if (a.bfsNummer > b.bfsNummer) {
      return 1;
    }
    if (a.kreisNummer === null && b.kreisNummer !== null) {
      return -1;
    }
    if (b.kreisNummer === null && a.kreisNummer !== null) {
      return 1;
    }
    if (a.kreisNummer === null && b.kreisNummer === null) {
      return 0;
    }
    if (!isNaN(parseInt(a.kreisNummer, 10)) && isNaN(parseInt(b.kreisNummer, 10))) {
      return -1;
    }
    if (isNaN(parseInt(a.kreisNummer, 10)) && !isNaN(parseInt(b.kreisNummer, 10))) {
      return 1;
    }
    if (isNaN(parseInt(a.kreisNummer, 10)) && isNaN(parseInt(b.kreisNummer, 10))) {
      if (a.kreisNummer > b.kreisNummer) {
        return 1;
      }
      if (a.kreisNummer < b.kreisNummer) {
        return -1;
      }
      return 0;
    }

    if (+(a.kreisNummer) > +(b.kreisNummer)) {
      return 1;
    }
    if (+(a.kreisNummer) < +(b.kreisNummer)) {
      return -1;
    }
    return 0;
  }

  sortByTitle(a: GbCompleterGemeindeListEntry, b: GbCompleterGemeindeListEntry) {
    if (a.title < b.title) {
      return -1;
    }
    if (a.title > b.title) {
      return 1;
    }
    return 0;
  }
}
